import request from '../../utils/request'
import store from '../../store/index'

// 获取通知对象列表
export const getNotificationList = (
  info,
  {
    page_size = store.getters.pageSize
  } = {}
) => {
  return request({
    url: '/admin-getNotifications',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size,
      scene: 'system',
      ...info
    }
  })
}
// 创建通知对象
export const addNotification = (info) => {
  return request({
    url: '/admin-addNotification',
    method: 'post',
    data: {
      notification: info
    }
  })
}
// 编辑通知对象
export const updateNotification = (info) => {
  return request({
    url: '/admin-updateNotification',
    method: 'post',
    data: {
      ...info
    }
  })
}
// 批量更通知对象
export const batchUpdateNotifications = (info) => {
  return request({
    url: '/admin-batchUpdateNotifications',
    method: 'post',
    data: {
      notifications: info
    }
  })
}
// 批量删除通知对象
export const deleteNotifications = (info) => {
  return request({
    url: '/admin-deleteNotifications',
    method: 'post',
    data: {
      notification_ids: info
    }
  })
}
// 获取通知对象详情
export const getNotificationDetail = (info) => {
  return request({
    url: '/admin-getNotificationDetail',
    method: 'GET',
    params: {
      notification_id: info
    }
  })
}
// 获取支持通知方式 - 创建通知对象
export const getSupportedNotificationMethods = () => {
  return request({
    url: '/getSupportedNotificationMethods',
    method: 'GET',
    params: {}
  })
}